import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

// Parâmetros → Vendas → "Habilitar recorrência": mostra o menu Vendas → Gerar
// Recorrência e a aba Recorrência do Cadastro de Clientes. Lido da
// organização (não do login), então vale assim que os Parâmetros são salvos
// (CadastroOrganizacao invalida esta chave).
export const CHAVE_RECORRENCIA_HABILITADA = 'org-recorrencia-habilitada';

export default function useRecorrenciaHabilitada() {
  const { usuario } = useAuth();
  const orgId = usuario?.organizacao_id;
  const { data = false } = useQuery({
    queryKey: [CHAVE_RECORRENCIA_HABILITADA, orgId],
    queryFn: () => api.get(`/organizacoes/${orgId}`).then(r => !!r.data?.recorrencia_habilitada),
    enabled: !!orgId,
    staleTime: 60_000,
  });
  return data;
}
